/** 웰스토리몰 */
export const SITE_WELMALL = '1000000001';
/** 대한항공 */
export const SITE_SKYPASS = 'N2507000011';
/** 한미글로벌 */
export const SITE_HANMI = 'N2508000016';
/* TYM */
export const SITE_TYM = 'N2603000024';
/* Kolon */
export const SITE_KOLON = 'N2603000025';
/* 아시아나 */
export const SITE_ASIANA = 'N2602000023';
/* 삼성전자 dx부문 가정의달 선물몰 */
export const SITE_SDX = 'N2603000035';
/* 웰플샵 */
export const SITE_WPS = 'N2512000020';

/** 리빙큐레이션 */
export const SITE_LIVING = 'N2603000042';
/** 대한항공 적립몰 */
// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
export const SITE_KOREANAIR_SAVINGS = 'N2603000028';
/** 프리티 */
export const SITE_FREET_MALL = 'N2603000039';
/** 삼성E&A 가족지원 서비스몰 */
export const SITE_SENA_FAMILY = 'N2603000038';
/** SKT 사전 */
export const SITE_SKT_EVENT = 'N2603000040';
/** 삼성생명서비스 기념일몰 */
export const SITE_SSLSVC = 'N2603000027';
/** 마이홈밀플래터 */
export const SITE_HOMEMEAL = 'N2603000031';
/** 웰스토리복지몰 */
export const SITE_MOP = 'N2603000032';
/** ECMJ - 윤희영 - 삼성전자 DS 생일포인트 신청몰 */
export const SITE_DS_BIRTH_POINT = 'N2603000029';
/** ECMJ: MDF - Insun Baek */
export const SITE_MDF = 'N2603000041';
/** 26년 추석 파트너사 선물몰 */
export const SITE_CHUSEOK = 'N2607000053'

/** 기본 설정 **/
const BASE_CONFIG = {
  showRating: true, //리뷰 보여주기 여부
  showGift: true, //선물하기 보여주기 여부
  myPageEditMenuUseYn: true, // 마이페이지 메뉴 : '내정보수정' 노출 여부
  myPasswordEditMenuUseYn: true, // 마이페이지 메뉴 : '비밀번호 변경' 노출 여부
  orderButtonText: undefined, // '바로주문' 버튼 텍스트 : 상품상세페이지
  payButtonText: undefined, // '결제하기' 버튼 텍스트 : 결제페이지
};

/** 출산선물몰 설정 **/
const BABY_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'babyMyPageLnbMenuItems', //마이페이지 좌측메뉴키 : '@fo-const/myPage/lnbMenuItemConst' 파일 참조
  showRating: false,
  showGift: false,
  orderButtonText: '신청하기',
  payButtonText: '신청하기',
  showGoodNumber: false, // 상품상세에서 상품코드 노출 여부
  showGoodBrand: false, // 상품상세에서 브랜드명 노출 여부
  paymentName: '신청서작성', //주문페이지 타이틀
  completeName: '신청완료', //주문완료페이지 타이틀
  orderGoodTitle: '신청상품', //주문페이지 상품정보 타이틀
  orderName: '신청', // 주문이 -> 신청이
  orderNoName: '신청번호', // 주문번호 -> 신청번호
  orderDateTimeName: '신청일', // 주문일 -> 신청일
  orderBuyerName: '신청자', // 주문자 -> 신청자
  showContinueShopping: false, // 주문완료페이지: '계속 쇼핑하기' 버튼 노출 여부
  showSwiperShareOrder: false, // 주문완료페이지: '주문상품 공유' 노출 여부
  myPageOrderGroupTitle: '신청현황', // 나이 쇼핑 -> 신청현황
  myPageOrderTitle: '신청조회', // 주문배송 -> 신청조회
  myPageOrderDetailTitle: '신청내역', // 주문상세 -> 신청내역
  myPageMenuGiftishowUseYn: false, // 마이페이지 메뉴 : '모바일 상품권 주문내역' 노출 여부
  prevOrdMenu: {
    useYn: true,
    name: '26.06.27 이전 신청조회',
  },
  isCustomerServiceMenuUseYn: false,
  showFooterEmailCollectionPopupButton: false,
  showFooterWelstorySiteButton: false,
};

const SBABY_CONFIG = {
  ...BABY_CONFIG,
  login: {
    userIdPlaceholder: 'knox ID',
    userPasswordPlaceholder: '',
  },
};

const STECOBABY_CONFIG = {
  ...BABY_CONFIG,
  login: {
    userIdPlaceholder: '사번',
    userPasswordPlaceholder: '',
  },
};

const SSLSVC_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'sslSvcMyPageLnbMenuItems',
  myPageEditMenuUseYn: false,
  myPasswordEditMenuUseYn: false,
  myPageMenuGiftishowUseYn: false, // 마이페이지 메뉴 : '모바일 상품권 주문내역' 노출 여부
  prevOrdMenu: {
    useYn: true,
    name: '26.06.27 이전 신청조회',
  },
};

/** 홈밀 (마이홈밀플래터) 설정 */
const HOMEMEAL_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'homemealMyPageLnbMenuItems', //마이페이지 좌측메뉴키 : '@fo-const/myPage/lnbMenuItemConst' 파일 참조
  isExhibitionRedirectUseYn: true,  // 특정 기획전으로 이동 처리여부
  showRating: false,
  showGift: false,
  orderButtonText: '신청하기',
  payButtonText: '신청하기',
  showGoodNumber: false, // 상품상세에서 상품코드 노출 여부
  showGoodBrand: false, // 상품상세에서 브랜드명 노출 여부
  paymentName: '신청서작성', //주문페이지 타이틀
  completeName: '신청완료', //주문완료페이지 타이틀
  orderGoodTitle: '신청상품', //주문페이지 상품정보 타이틀
  orderName: '신청', // 주문이 -> 신청이
  orderNoName: '신청번호', // 주문번호 -> 신청번호
  orderDateTimeName: '신청일', // 주문일 -> 신청일
  orderBuyerName: '신청자', // 주문자 -> 신청자
  showContinueShopping: false, // 주문완료페이지: '계속 쇼핑하기' 버튼 노출 여부
  showSwiperShareOrder: false, // 주문완료페이지: '주문상품 공유' 노출 여부
  myPageOrderGroupTitle: '신청현황', // 나이 쇼핑 -> 신청현황
  myPageOrderTitle: '신청조회', // 주문배송 -> 신청조회
  myPageOrderDetailTitle: '신청내역', // 주문상세 -> 신청내역
  myPageMenuGiftishowUseYn: false, // 마이페이지 메뉴 : '모바일 상품권 주문내역' 노출 여부
  prevOrdMenu: {
    useYn: true,
    name: '26.06.27 이전 신청조회',
  },
};
/** ECMJ - 윤희영 - 삼성전자 DS 생일포인트 신청몰 설정 **/
const DS_BIRTH_POINT_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'dsBirthPointMyPageLnbMenuItems',
  hideSignUpButtonOnPc: true, // PC 회원가입 버튼 숨김 (DS는 SSO 자동 진입만, MO는 노출 유지)
  showRating: false,
  showCardBenfit: false,
  prevOrdMenu: {
    useYn: true,
    name: '26.06.27 이전 신청조회',
  },
  myPageEditMenuUseYn: false,
  myPasswordEditMenuUseYn: false,
  welPointName: '생일포인트',
};

const SITE_SKYPASS_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'skypassMyPageLnbMenuItems',
  showGift: false,
  showCartUseInfo: false,
  showDeliveryCostAndDiscounted: false,
  showRefundTab: false,
  isRefundTabEmployee: false,
};

const KOREANAIR_SAVINGS_CONFIG = {
  ...BASE_CONFIG,
  showGift: false,
  showCartUseInfo: false,
  showDeliveryCostAndDiscounted: false,
  showRefundTab: true,
  isRefundTabEmployee: false, //배송/반품/교환탭 - 임직원 대상 쇼핑몰이므로
  myPageLnbMenuItemsKey: 'koreanAirSavingsMyPageLnbMenuItems',
  myPageEditMenuUseYn: false,
  myPasswordEditMenuUseYn: false,
  myPagePointMenuUseYn: true,
  myPageMenuGiftishowUseYn: false,
  myPageMenuReceiptUseYnEventMall: true,
  prevOrdMenu: {
    useYn: true,
    name: '26.06.27 이전 주문조회',
  },
  myPageShowEmail: false,
  isCustomerServiceMenuUseYn: false, // 고객센터 노출 여부
  isShowFaqInformationBtn: false, // 마이페이지 주문정보 '1:1문의' 노출 여부
  showFooterWelstorySiteButton: false,
  isCancelRefundGuideExceptQnaPoint: true, //취소환불 안내 - CANCEL_REFUND_GUIDES_EXCEPT_QNA_POINT
};

/** 리빙큐레이션 (임직원 우대몰) 설정 */
const LIVING_CONFIG = {
  ...BASE_CONFIG,
  myPageMenuGiftishowUseYn: false,
};

/** 우대몰 (웰스토리 복지몰) 설정 */
const MOP_CONFIG = {
  ...BASE_CONFIG,
  isExhibitionRedirectUseYn: true,  // 특정 기획전으로 이동 처리여부
  isCookieGateUseYn: true,  // 쿠키 값으로 Gate 체크 사용여부 (로그인 이전 상태 포함)
  cookieGateName: 'MOP_COOKIE_NAME',
  myPageLnbMenuItemsKey: 'mopMyPageLnbMenuItems',
  myPageMenuGiftishowUseYn: false,
  prevOrdMenu: {
    useYn: true,
    name: '26.06.27 이전 신청조회',
  },
};

/** 삼성E&A 가족지원 서비스몰 설정 **/
const SITE_SENA_FAMILY_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'senafamilyMyPageLnbMenuItems',
  showFooterEmailCollectionPopupButton: false,
  showFooterWelstorySiteButton: false,
  myPageMenuReceiptUseYnEventMall: true,
  prevOrdMenu: {
    useYn: true,
    name: '26.06.27 이전 주문조회',
  },
  isCustomerServiceMenuUseYn: false, // 고객센터 노출 여부
  isShowFaqInformationBtn: false, // 마이페이지 주문정보 '1:1문의' 노출 여부
};

/** ECMJ: MDF - Insun Baek */
const MDF_CONFIG = {
  ...BASE_CONFIG,
  myPageMenuGiftishowUseYn: false,
  myPageEditMenuUseYn: false,
  isDeliveryAdressMenuUseYn: false,
  isMyActivityMenuUseYn: false,
  isCustomerServiceMenuUseYn: false,
  prevOrdMenu: {
    useYn: false,
    name: '26.06.27 이전 주문조회',
  },
};

/** 26년 추석 파트너사 선물몰 */
const CHUSEOK_CONFIG = {
  ...BASE_CONFIG,
  login:{
    userIdPlaceholder:'',
    userPasswordPlaceholder:''
  }
};

const SITE_TYM_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'tymMyPageLnbMenuItems',
  isMyActivityMenuUseYn: false,
  myPageMenuGiftishowUseYn: false,
}
const SITE_KOLON_CONFIG = {
  ...BASE_CONFIG,
  myPageLnbMenuItemsKey: 'kolonMyPageLnbMenuItems',
  isMyActivityMenuUseYn: false,
  myPageMenuGiftishowUseYn: false,
}

const SITE_LIST = Object.freeze({
  SITE_SBABY: { SITE_NO: 'N2603000033', config: SBABY_CONFIG}, /** 삼성전자 출산선물 */
  SITE_STECOBABY: { SITE_NO: 'N2603000034', config: STECOBABY_CONFIG}, /** 스테코 출산선물 */
  SITE_SSLSVC: { SITE_NO: SITE_SSLSVC, config: SSLSVC_CONFIG}, /** 삼성생명서비스 기념일몰 */
  SITE_HOMEMEAL: { SITE_NO: SITE_HOMEMEAL, config: HOMEMEAL_CONFIG } /** 홈밀 */,
  SITE_MOP: { SITE_NO: SITE_MOP, config: MOP_CONFIG } /** 웰스토리복지몰 */,
  SITE_DS_BIRTH_POINT: {
    SITE_NO: SITE_DS_BIRTH_POINT,
    config: DS_BIRTH_POINT_CONFIG,
  } /** ECMJ - 윤희영 - 삼성전자 DS 생일포인트 신청몰 */,
  SITE_SENA_FAMILY: { SITE_NO: 'N2603000038', config: SITE_SENA_FAMILY_CONFIG } /** 삼성E&A 가족지원 서비스몰 **/,
  SITE_SKYPASS: { SITE_NO: SITE_SKYPASS, config: SITE_SKYPASS_CONFIG}, /** 대한항공 소진몰 */
  SITE_KOREANAIR_SAVINGS: { SITE_NO: 'N2603000028', config: KOREANAIR_SAVINGS_CONFIG}, /** 대한항공 적립몰 */
  SITE_LIVING: { SITE_NO: SITE_LIVING, config: LIVING_CONFIG}, /** 리빙큐레이션 */
  SITE_MDF: { SITE_NO: SITE_MDF, config: MDF_CONFIG } /** ECMJ: MDF - Insun Baek */,
  SITE_CHUSEOK:{ SITE_NO: SITE_CHUSEOK, config: CHUSEOK_CONFIG }, /** 26년 추석 파트너사 선물몰 */
  SITE_TYM: { SITE_NO: SITE_TYM, config: SITE_TYM_CONFIG }, /** tym */
  SITE_KOLON: { SITE_NO: SITE_KOLON, config: SITE_KOLON_CONFIG }, /** kolon */
});

/** 출산선물 여부 확인 */
const isBaby = (siteNumber) => {
  return siteNumber === SITE_LIST.SITE_SBABY.SITE_NO || siteNumber === SITE_LIST.SITE_STECOBABY.SITE_NO;
};

/** 사이트번호로 사이트 정보 리턴 **/
const getSite = (siteNumber) => {
  return Object.values(SITE_LIST).find(item => item.SITE_NO === siteNumber);
};
/** 사이트번호로 사이트 설정 리턴 **/
const getSiteConfig = (siteNumber) => {
  return getSite(siteNumber)?.config;
};

/** 마이페이지 LNB 키 **/
const myPageLnbMenuItemsKey = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageLnbMenuItemsKey;
};
/** 상품 리뷰 보이기 여부 **/
const showRating = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showRating ?? true;
};
/** 선물 버튼 보이기 여부 **/
const showGift = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showGift ?? true;
};
const showCartUseInfo = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showCartUseInfo ?? true;
};
const showDeliveryCostAndDiscounted = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showDeliveryCostAndDiscounted ?? true;
};
const showRefundTab = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showRefundTab ?? false;
};
const isRefundTabEmployee = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isRefundTabEmployee ?? true;
};
/** 주문버튼 텍스트 **/
const orderButtonText = (siteNumber) => {
  return getSiteConfig(siteNumber)?.orderButtonText;
};
/** 결제버튼 텍스트 **/
const payButtonText = (siteNumber) => {
  return getSiteConfig(siteNumber)?.payButtonText;
};
/** 특정 기획전으로 이동 처리여부 */
const isExhibitionRedirectUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isExhibitionRedirectUseYn ?? false;
};
const showGoodNumber = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showGoodNumber ?? true;
};
const showGoodBrand = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showGoodBrand ?? true;
};
const cartName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.cartName;
};
const paymentName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.paymentName;
};
const completeName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.completeName;
};
const orderGoodTitle = (siteNumber) => {
  return getSiteConfig(siteNumber)?.orderGoodTitle;
};
const orderName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.orderName;
};
const orderNoName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.orderNoName;
};
const orderDateTimeName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.orderDateTimeName;
};
const orderBuyerName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.orderBuyerName;
};
const showContinueShopping = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showContinueShopping ?? true;
};
const showSwiperShareOrder = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showSwiperShareOrder ?? true;
};
const myPageOrderGroupTitle = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageOrderGroupTitle;
};
const myPageOrderTitle = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageOrderTitle;
};
const myPageOrderDetailTitle = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageOrderDetailTitle;
};
const myPageMenuGiftishowUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageMenuGiftishowUseYn ?? true;
};
const myPageMenuReceiptUseYnEventMall = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageMenuReceiptUseYnEventMall ?? false;
};
const isPrevOrdMenuUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.prevOrdMenu?.useYn ?? false;
};
const prevOrdMenuName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.prevOrdMenu?.name;
};
const myPageEditMenuUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageEditMenuUseYn ?? true;
};
const myPasswordEditMenuUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPasswordEditMenuUseYn ?? true;
};
const myPagePointMenuUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPagePointMenuUseYn ?? false;
};
const myPageShowEmail = (siteNumber) => {
  return getSiteConfig(siteNumber)?.myPageShowEmail ?? true;
};
const isCustomerServiceMenuUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isCustomerServiceMenuUseYn ?? true;
};
const isShowFaqInformationBtn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isShowFaqInformationBtn ?? true;
};
const showFooterEmailCollectionPopupButton = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showFooterEmailCollectionPopupButton ?? true;
};
const showFooterWelstorySiteButton = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showFooterWelstorySiteButton ?? true;
};
const isCancelRefundGuideExceptQnaPoint = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isCancelRefundGuideExceptQnaPoint ?? false;
};
// ECMJ - 윤희영
const hideSignUpButtonOnPc = (siteNumber) => {
  return getSiteConfig(siteNumber)?.hideSignUpButtonOnPc ?? false;
};
const isCookieGateUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isCookieGateUseYn ?? false;
};
const cookieGateName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.cookieGateName;
};
// 결제혜택
const showCardBenfit = (siteNumber) => {
  return getSiteConfig(siteNumber)?.showCardBenfit ?? true;
};
const isDeliveryAdressMenuUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isDeliveryAdressMenuUseYn ?? true;
};
const isMyActivityMenuUseYn = (siteNumber) => {
  return getSiteConfig(siteNumber)?.isMyActivityMenuUseYn ?? true;
};
const welPointName = (siteNumber) => {
  return getSiteConfig(siteNumber)?.welPointName;
};
export const SiteNumberFunc = {
  isBaby,
  getSiteConfig,
  myPageLnbMenuItemsKey,
  showRating,
  showGift,
  showCartUseInfo,
  showDeliveryCostAndDiscounted,
  showRefundTab,
  isRefundTabEmployee,
  orderButtonText,
  payButtonText,
  showGoodNumber,
  showGoodBrand,
  cartName,
  paymentName,
  completeName,
  orderGoodTitle,
  orderName,
  orderNoName,
  orderDateTimeName,
  orderBuyerName,
  showContinueShopping,
  showSwiperShareOrder,
  myPageOrderGroupTitle,
  myPageOrderTitle,
  myPageOrderDetailTitle,
  myPageMenuGiftishowUseYn,
  myPageMenuReceiptUseYnEventMall,
  isPrevOrdMenuUseYn,
  prevOrdMenuName,
  myPageEditMenuUseYn,
  myPasswordEditMenuUseYn,
  myPagePointMenuUseYn,
  myPageShowEmail,
  isCustomerServiceMenuUseYn,
  isShowFaqInformationBtn,
  showFooterEmailCollectionPopupButton,
  showFooterWelstorySiteButton,
  isCancelRefundGuideExceptQnaPoint,
  isExhibitionRedirectUseYn,
  hideSignUpButtonOnPc,
  isCookieGateUseYn,
  cookieGateName,
  showCardBenfit,
  isDeliveryAdressMenuUseYn,
  isMyActivityMenuUseYn,
  welPointName,
};
